// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/infographic-page-center/infographic-page-center.component.scss
// module id = 388
// module chunks = 0